<template>
    <span>
    <button type="button" class="btn btn-sm btn-cog"
        :id="'popover-config-' + content.id">
        <i class="material-icons">settings</i>
        <b-popover :target="'popover-config-' + content.id"
            triggers="click blur"
            placement="bottom"
            ref="popover">
            <div>
                <b-form-group
                    v-for="configField in config.fields"
                    :key="configField">
                    <b-form-checkbox
                        v-on:input="(value) => updateField(configField, value)"
                        value="1"
                        unchecked-value="0"
                        :checked="content[configField]">
                        {{formatLabel(configField)}}
                    </b-form-checkbox>
                </b-form-group>
            </div>
        </b-popover>
    </button>
    </span>
</template>
<script>
import V from 'voca';

export default {
    data() {
        return {

        }
    },

    props: ['content', 'config', 'updateBatch'],

    methods: {
        updateField(field, value) {
            if (this.content[field] == value) return;
            this.updateBatch([
                { id: this.content.id, $update: { [field]: parseInt(value) } },
            ], {
                setNotification: true,
            });
        },

        formatLabel(value) {
            return V.capitalize(value).replace(/[\_]/g, ' ');
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/PopoverConfigComponent.vue